import { ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { ROUTE_TRANSITION } from '../../../app.animation';
import { HttpClient } from '@angular/common/http';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';

import {I18n} from '@ngx-translate/i18n-polyfill';

import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../core/auth/auth.service';

@Component({
  selector: 'vr-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  animations: [...ROUTE_TRANSITION],
  host: { '[@routeTransition]': '' }
})
export class LoginComponent {
  errors = {};
  isLoading: boolean;
  data = {
    user : {
      email: '',
      password: ''
    }
  };

  loginForm: FormGroup;
  email = new FormControl('', Validators.required);
  password = new FormControl('', Validators.required);

  constructor(
    private snackBar: MatSnackBar,
    private router: Router,
    private authService: AuthService,
    private http: HttpClient,
    private i18n: I18n,
    protected changeDetectorRefs: ChangeDetectorRef
  ) {
    this.isLoading = false;

    this.loginForm = new FormGroup({
      email: this.email,
      password: this.password
    });

  }

  /**
   * Show error message
   * @param param
   */
  getErrorMessage(param) {
    if (param === 'email') {
      return (this.email.hasError('required') && this.i18n({value: 'You must enter a value.', id: 'FormNoValue'})) || (this.errors['email'] && this.errors['email'].message);
    } else if (param === 'password') {
      return (this.password.hasError('required') && this.i18n({value: 'You must enter a value.', id: 'FormNoValue'})) || (this.errors['password'] && this.errors['password'].message);
    } else if (param === 'active') {
      return this.errors['active'] && this.errors['active'].message;
    } else if (param === 'subscription') {
      return this.errors['subscription'] && this.errors['subscription'].message;
    }
  }

  /**
   * Send login request
   */
  submitForm() {
    this.errors = {};
    this.isLoading = true;
    this.http.post(environment.API_PATH + 'auth/login', {user: this.loginForm.value}, {withCredentials: true}).subscribe(response => {
      this.isLoading = false;
      if (response['success']) {
        this.authService.login();
      } else {
        this.errors = response['errors'];
        if ('general' in response['errors']) {
          this.snackBar.open(response['errors']['general']['message'], '' , { duration: 5000 } as MatSnackBarConfig);
        } else {
          this.snackBar.open(this.i18n({value: 'Errors have been found, please check the fields.', id: 'ErrorsHaveBeenFound'}), '', {duration: 5000} as MatSnackBarConfig);
          for (const key in this.errors) {
            if (this.errors.hasOwnProperty(key)) {
              if (key in this.loginForm.controls) {
                this.loginForm.controls[key].setErrors(({ key: this.errors[key]['message'] }));
                this.loginForm.controls[key].markAsTouched();
              }
            }
          }
        }
      }
    }, () => {
      this.isLoading = false;
      this.changeDetectorRefs.detectChanges();
      this.snackBar.open(this.i18n({value: 'Errors have been found, please check the fields.', id: 'ErrorsHaveBeenFound'}), '', {duration: 5000} as MatSnackBarConfig);
    });
  }

  userDisabled() {
    return this.errors['active'];
  }

  enterpriseUnsubscribed() {
    return this.errors['subscription'];
  }

}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/pages/auth/login/login.component.ts